export default __webpack_public_path__ + "static/media/abcdropfour.c436c9e9.png";